export default "__VITE_ASSET__BqrnmsHl__";